/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMath1Divide3 = createReactComponent("outline", "math-1-divide-3", "IconMath1Divide3", [["path", { "d": "M10 15.5a.5 .5 0 0 1 .5 -.5h2a1.5 1.5 0 0 1 0 3h-1.167h1.167a1.5 1.5 0 0 1 0 3h-2a.5 .5 0 0 1 -.5 -.5", "key": "svg-0" }], ["path", { "d": "M5 12h14", "key": "svg-1" }], ["path", { "d": "M10 5l2 -2v6", "key": "svg-2" }]]);

export { IconMath1Divide3 as default };
//# sourceMappingURL=IconMath1Divide3.mjs.map
